import { InjectionToken } from '@angular/core';
import { ItemPricesConfig } from './item-prices.config';
import { ItemPricesService } from './item-prices.service';
import { ItemPricesStore } from './item-prices.store';

export const ITEM_PRICES_CONFIG = new InjectionToken<ItemPricesConfig>(
  'ItemPrices config',
);

/**
 * Provide a scoped ItemPricesService + ItemPricesStore bound to a specific
 * entity API endpoint. Call this in the `providers` array of the relevant route.
 *
 * @example
 * ```ts
 * {
 *   path: 'cennik',
 *   providers: [provideItemPrices({ apiEndpoint: '/serv-packages' })],
 *   loadComponent: () => import(...).then(m => m.ServPackagePricesTabComponent),
 * }
 * ```
 */
export const provideItemPrices = (config: ItemPricesConfig) => {
  const cfg = { ...config };
  if (!cfg.apiEndpoint.startsWith('/')) {
    cfg.apiEndpoint = '/' + cfg.apiEndpoint;
  }
  return [
    { provide: ITEM_PRICES_CONFIG, useValue: cfg },
    ItemPricesService,
    ItemPricesStore,
  ];
};
